import { ACTIVITY_LOG_AGENT_FALLBACK_LABEL, serializeActivityLogContent } from './activityLogMentions';

type ActivityLogPlainTextInlineNode =
  | {
      type: 'text';
      text: string;
    }
  | {
      type: 'hardBreak';
    };

type ActivityLogPlainTextDoc = {
  type: 'doc';
  content: Array<{
    type: 'paragraph';
    content?: ActivityLogPlainTextInlineNode[];
  }>;
};

function createParagraphContent(value: string): ActivityLogPlainTextInlineNode[] | undefined {
  if (!value) {
    return undefined;
  }

  return value.split('\n').flatMap((line, index, lines) => {
    const lineNodes: ActivityLogPlainTextInlineNode[] = line ? [{ type: 'text', text: line }] : [];

    if (index === lines.length - 1) {
      return lineNodes;
    }

    return [...lineNodes, { type: 'hardBreak' }];
  });
}

export function createPlainTextActivityLogDoc(value: string): ActivityLogPlainTextDoc {
  const normalizedValue = value.replaceAll(/\r\n?/g, '\n');

  return {
    type: 'doc',
    content: normalizedValue.split(/\n{2,}/).map((paragraph) => {
      const content = createParagraphContent(paragraph);

      return {
        type: 'paragraph',
        ...(content ? { content } : {}),
      };
    }),
  };
}

export function buildPlainTextActivityLogContent(value: string) {
  const doc = createPlainTextActivityLogDoc(value);
  const { markdown, plaintext } = serializeActivityLogContent(doc, ACTIVITY_LOG_AGENT_FALLBACK_LABEL);

  return {
    markdown,
    plaintext,
    formatVersion: 2,
    editorStateJson: JSON.stringify(doc),
  };
}
